module.exports = __webpack_public_path__ + "img/rekon_delivery.18a473e4.svg";